export const uppercaseOnlyFirstLetter = (
  text: string,
  maxTextLength?: number
): string => {
  if (!text) return '';

  let aux = text.toLowerCase().split(' ');
  aux = aux.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  text = aux.join(' ');

  if (maxTextLength && text.length > maxTextLength) {
    text = textEllipsis(text, maxTextLength);
  }

  return text;
};

export const textEllipsis = (text: string, maxTextLength: number): string => {
  return text.length > maxTextLength
    ? `${text.substring(0, maxTextLength)}...`
    : text;
};

export const makeid = (length: number): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const camelize = (word: string) => {
  return word
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

export const cnpjMask = (cnpj: string): string => {
  cnpj = cnpj.replace(/\D/g, ''); //Remove tudo o que não é dígito
  if (cnpj.length > 14) {
    cnpj = cnpj.slice(0, 14)[0];
  }
  cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2'); //Coloca ponto entre o segundo e o terceiro dígitos
  cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto dígitos
  cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2'); //Coloca uma barra entre o oitavo e o nono dígitos
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2'); //Coloca um hífen depois do bloco de quatro dígitos

  return cnpj;
};

export const phoneMask = (phone: string): string => {
  phone = phone.replace(/\D/g, ''); //Remove tudo o que não é dígito
  phone = phone.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1)$2-$3'); //Formata para (99)99999-9999
  return phone;
};

export const cpfMask = (cpf: string): string => {
  cpf = cpf.replace(/\D/g, ''); //Remove tudo o que não é dígito
  cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4'); //Formata para 999.999.999-99
  return cpf;
};

export const bornDateMask = (bornDate: string): string => {
  bornDate = bornDate.replace(/\D/g, ''); //Remove tudo o que não é dígito
  bornDate = bornDate.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3'); //Formata para 00/00/0000
  return bornDate;
};

export const removeSpecialCharacters = (text: string) => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const formatTaggingString = (text: string) => {
  const result = removeSpecialCharacters(text.toLowerCase())
    .trim()
    .replace(/ /g, '_');
  return result ? result : 'not_set';
};

export const capitalizeWords = (text: string) => {
  return text
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
